import { t } from '@lingui/macro';
import { AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function TypeAvatarWithLabel(props) {
    const { title, truncate, type, subtitle } = props;
    const types = {
        folder: {
            icon: <Falcon icon="folder"/>,
            appearance: 'primary',
            shape: 'square',
            solid: true,
            tooltip: t({ message: 'Folder', comment: 'Folder tooltip in type avatar' }),
        },
        'folder:locked': {
            icon: <Falcon icon="lock"/>,
            appearance: 'primary',
            shape: 'square',
            solid: false,
            tooltip: t({ message: 'No access', comment: 'Folder tooltip in type avatar' }),
        },
        file: {
            icon: <Falcon icon="file"/>,
            appearance: 'light',
            shape: 'circle',
            solid: false,
            tooltip: t({ message: 'File', comment: 'File tooltip in type avatar' }),
        },
        'file:locked': {
            icon: <Falcon icon="lock"/>,
            appearance: 'light',
            shape: 'circle',
            solid: false,
            tooltip: t({ message: 'No access', comment: 'File tooltip in type avatar' }),
        },
        'file:composed': {
            icon: <Falcon icon="file"/>,
            appearance: 'light',
            shape: 'circle',
            solid: false,
            tooltip: t({ message: 'Composed document', comment: 'File tooltip in type avatar' }),
        },
        'file:freetext': {
            icon: <Falcon icon="file"/>,
            appearance: 'light',
            shape: 'circle',
            solid: false,
            tooltip: t({ message: 'Freetext document', comment: 'File tooltip in type avatar' }),
        },
        'file:uploaded': {
            icon: <Falcon icon="file"/>,
            appearance: 'light',
            shape: 'circle',
            solid: false,
            tooltip: t({ message: 'Uploaded document', comment: 'File tooltip in type avatar' }),
        },
        draft: {
            icon: <Falcon icon="copy"/>,
            appearance: 'warning',
            shape: 'circle',
            solid: false,
            tooltip: t({ message: 'Ongoing template', comment: 'File tooltip in type avatar' }),
        },
    };
    const { icon, appearance, shape, solid, tooltip } = types[type];
    return (<AvatarWithLabel title={title} subtitle={subtitle} truncate={truncate} appearance={appearance} shape={shape} solid={solid} size="md" avatarTooltip={{ title: tooltip, disabled: !tooltip, position: 'left' }}>
      {icon}
    </AvatarWithLabel>);
}
